




















































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import {
  ETableColumnType,
  EUserPermissionsCategory,
  ISelectItem,
  ITableConfig,
  IUserPermissionItem
} from '@/interfaces'
import { USER_PERMISSIONS_LIST } from '@/constants'
import { PermissionsModule } from '@/store/modules/permissions.module'
import {
  EUserPermissions,
  IUserChainRole,
  IUserRolePermission,
  getIdFromEntityField,
  OPCOChainId,
  ExclusiveOPCOChainPermissions,
  DisabledAllChainsPermissions
} from '@zunta/configurations'
import Api from '@/api'
import { User } from '@/classes/User'
import Table from '@/components/tables/Table.vue'
import Card from '@/components/Card.vue'
import ModifyRoleModal from '@/views/app/management/settings/components/ModifyRoleModal.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { Debounce } from 'vue-debounce-decorator'

@Component({
  components: {
    LoaderWrapper,
    ModifyRoleModal,
    Card,
    Table,
    Icon,
    Checkbox
  }
})
export default class ManagementUsersPermissions extends Vue {
  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  EUserPermissions: any = EUserPermissions

  user: User = Api.getUser() as User

  filters: any = null
  hasPrev: any = false
  hasNext: any = false

  reloadPermissions: number = 0
  isLoading: boolean = false

  wantModifyRoles: boolean = false
  firstLoad: boolean = true

  get config (): ITableConfig {
    return {
      clearFilterBtn: {
        wrapperClass: 'bt-d-none position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px);'
      },
      stickyScrollbar: true,
      disablePreloader: true,
      fetchFunction: this.fetchOrFilter,
      debounceTime: 100,
      rowClass: 'h-45px',
      minHeight: 'calc(100vh - 365px)',
      columns: [
        {
          minWidth: '220px',
          maxWidth: '220px',
          key: 'name',
          searchKey: 'name',
          hasSearch: true,
          label: 'Permission',
          type: ETableColumnType.default
        },
        {
          minWidth: '150px',
          maxWidth: '150px',
          key: 'category',
          searchKey: 'category',
          hasSearch: true,
          label: 'Category',
          type: ETableColumnType.select,
          options: this.categoryListItems
        },
        {
          minWidth: '350px',
          maxWidth: '350px',
          key: 'description',
          searchKey: 'description',
          hasSearch: true,
          label: 'Description',
          type: ETableColumnType.default
        }
      ]
    }
  }

  get config2 (): ITableConfig {
    const config: ITableConfig = {
      clearFilterBtn: {
        wrapperClass: 'bt-d-none position-absolute'
      },
      disablePreloader: true,
      stickyScrollbar: true,
      fetchFunction: this.filter2,
      debounceTime: 100,
      rowClass: 'h-45px',
      minHeight: 'calc(100vh - 365px)',
      columns: []
    }

    config.columns = this.rolesList.map((role: any) => {
      return {
        minWidth: '135px',
        maxWidth: '135px',
        key: `2role${role.id}`,
        searchKey: `role${role.id}`,
        hasSearch: true,
        label: role.name,
        type: ETableColumnType.select,
        options: [
          {
            key: 'true',
            value: 'selected',
            content: 'Selected'
          },
          {
            key: 'false',
            value: 'notselected',
            content: 'Not Selected'
          }
        ]
      }
    })

    return config
  }

  get permissionsList () {
    return this.$store.state.permissions.permissions
  }

  get rolesList () {
    return this.$store.state.permissions.roles
  }

  get categoryListItems (): ISelectItem[] {
    return Object.values(EUserPermissionsCategory).map((permissionCategory: string): ISelectItem => ({
      content: permissionCategory,
      value: permissionCategory,
      key: permissionCategory
    }))
  }

  get userPermissionsList () {
    if (!this.filters) {
      return USER_PERMISSIONS_LIST
    }
    return USER_PERMISSIONS_LIST.filter((permissionItem: IUserPermissionItem) => {
      for (const field of ['name', 'category', 'description']) {
        if (this.filters[field] && !new RegExp(`${this.filters[field]}`, 'i').test((permissionItem as any)[field])) {
          return false
        }
      }

      const roleKeys = Object.keys(this.filters).filter((key: string) => key.includes('role'))
        .map((key: string) => Number(key.replace('role', '')))

      if (roleKeys.length) {
        for (const roleKey of roleKeys) {
          const filterRole = this.filters[`role${roleKey}`]

          if (filterRole === 'all' || !filterRole) {
            continue
          }

          const permissionChecked = !!this.permissionsList
            .filter((permission: IUserRolePermission) => permission.role === roleKey)
            .find((permission: IUserRolePermission) => permission.permission === permissionItem.permission)

          if (filterRole === 'selected' && !permissionChecked) {
            return false
          }

          if (filterRole === 'notselected' && permissionChecked) {
            return false
          }
        }
      }
      return true
    })
  }

  scrollTable (event: any) {
    const els = document.querySelectorAll('#sync-scroll')
    els.forEach((el: any) => {
      if (el !== event) {
        el.scrollTop = event.scrollTop
      }
    })
  }

  async changeUserPermission (role: IUserChainRole, permissionItem: IUserPermissionItem, checked: boolean) {
    if (!this.user.hasPermissionFor(EUserPermissions.EDIT_PERMISSIONS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: 'Edit Permissions',
        icon: 'warning'
      })
      this.reloadPermissions++
      return
    }

    if (checked) {
      await this.permissionsModuleInstance.addPermission({
        roleId: role.id,
        permission: permissionItem.permission
      })
      return
    }

    await this.permissionsModuleInstance.deletePermission({
      roleId: role.id,
      permission: permissionItem.permission
    })
  }

  isPermissionChecked (role: IUserChainRole, permissionItem: IUserPermissionItem) {
    return !!this.permissionsList
      .filter((permission: IUserRolePermission) => permission.role === role.id)
      .find((permission: IUserRolePermission) => permission.permission === permissionItem.permission)
  }

  isDisabledPermission (item: IUserPermissionItem) {
    const userChain = this.user.data.chain ? getIdFromEntityField(this.user.data.chain) : null
    const disabled = true
    if (!userChain) { return disabled }
    if (DisabledAllChainsPermissions.includes(item.permission)) {
      return disabled
    }
    if (ExclusiveOPCOChainPermissions.includes(item.permission)) {
      return userChain === OPCOChainId ? !disabled : disabled
    }
    return !disabled
  }

  async fetchOrFilter (filters: any) {
    this.isLoading = true

    // @ts-ignore
    if (this.$refs.table2) {
      // @ts-ignore
      this.$refs.table2.overflow = 'hidden'
    }

    if (this.firstLoad) {
      this.firstLoad = false
      await Promise.all([
        this.permissionsModuleInstance.getPermissions(),
        this.permissionsModuleInstance.getUserRoles()
      ])

      this.calcHasScroll()
      window.addEventListener('resize', this.calcHasScroll)
    }

    this.setFilters(filters, ['name', 'category', 'description'])

    this.$nextTick(() => {
      // @ts-ignore
      if (this.$refs.table2) {
        // @ts-ignore
        this.$refs.table2.onResize()
      }
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    })
  }

  filter2 (filters: any) {
    if (this.firstLoad) {
      return
    }
    this.isLoading = true

    this.setFilters(filters, [...this.rolesList.map((role: any) => 'role' + role.id)])

    this.$nextTick(() => {
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    })
  }

  clearFilters () {
    this.isLoading = true

    this.filters = null
    // @ts-ignore
    this.$refs.table1.filterObj = {}
    // @ts-ignore
    this.$refs.table1.$refs.tableHeader.filters = {}

    // @ts-ignore
    this.$refs.table2.filterObj = {}
    // @ts-ignore
    this.$refs.table2.$refs.tableHeader.filters = {}

    this.$nextTick(() => {
      setTimeout(() => {
        this.isLoading = false
      }, 150)
    })
  }

  setFilters (filters: any, keys: string[]) {
    if (!this.filters) {
      this.filters = { ...filters }
      return
    }

    const newFilters = { ...this.filters }

    delete newFilters['limit']
    delete newFilters['skip']

    keys.forEach((key: string) => {
      if (filters && !filters[key] && newFilters[key]) {
        delete newFilters[key]
        return
      }

      if (filters && filters[key]) {
        newFilters[key] = filters[key]
      }
    })

    this.filters = !newFilters || !Object.keys(newFilters).length
      ? null
      : newFilters
  }

  prev () {
    const wrapper: Element | null = document.querySelector('.table-scrollable .table-wrapper')
    if (wrapper) {
      wrapper.scrollLeft = wrapper.scrollLeft - 135
    }
  }

  next () {
    const wrapper: Element | null = document.querySelector('.table-scrollable .table-wrapper')
    if (wrapper) {
      wrapper.scrollLeft = wrapper.scrollLeft + 135
    }
  }

  @Debounce(100)
  calcHasScroll () {
    const wrapper: Element | null = this.$el.querySelector('.table-scrollable .table-wrapper')
    const table: Element | null = this.$el.querySelector('.table-scrollable .table-wrapper .table')
    const prev: Element | null = this.$el.querySelector('#prev')
    const next: Element | null = this.$el.querySelector('#next')

    if (!prev || !next) {
      return
    }

    if (!wrapper || !table) {
      this.hasNext = false
      this.hasPrev = false
      // @ts-ignore
      this.$el.querySelector('#prev').classList.add('disabled')
      // @ts-ignore
      this.$el.querySelector('#next').classList.add('disabled')
      return
    }

    this.hasPrev = wrapper.scrollLeft !== 0
    this.hasNext = Math.round(table.scrollWidth) - Math.round(wrapper.scrollLeft) - Math.round(wrapper.clientWidth) > 0

    if (!this.hasPrev) {
      // @ts-ignore
      this.$el.querySelector('#prev').classList.add('disabled')
    } else {
      // @ts-ignore
      this.$el.querySelector('#prev').classList.remove('disabled')
    }

    if (!this.hasNext) {
      // @ts-ignore
      this.$el.querySelector('#next').classList.add('disabled')
    } else {
      // @ts-ignore
      this.$el.querySelector('#next').classList.remove('disabled')
    }
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.calcHasScroll)
  }
}
